import * as React from "react"
import { Box } from "@mui/material"


/** The recommended price and its currency, as stored (`float` + `varchar(3)`). */
export default function priceColumn() {
    return {
        name: 'price', label: 'RRSP',
        options: {
            headerAlign: 'center',
            setCellProps: () => ({ sx: { textAlign: "center" } }),
            customBodyRowRenderLite: (value, row) => <Box display="flex" justifyContent="center">
                {value === null || value === undefined
                    ? '—'
                    : `${value} ${row.currency ?? ''}`.trim()}
            </Box>
        }
    }
}
